module.exports = __webpack_public_path__ + "static/media/system-smart.a6367dd0.svg";